export const resources = {
  SpeechInUseFailedDeleteDatasetText: '',
  SpeechGeneralFailedDeleteDatasetText: '',
  SpeechOnIndexingFailedDeleteModelTitle: '',
  SpeechGeneralFailedDeleteModelText: ''
};
